import React from 'react'
import './about.css'
import { Link } from 'react-router-dom'
import './home.css'
import { miscService } from "../service/misc.service";
import { useEffect, useState } from 'react'
import { AnimatedCounter } from './AnimatedCounter';
import SEO from './SEO';


const AboutUs = () => {

  const [countData, setCountData] = useState({})


  useEffect(() => {
    getDashboardCounts()
  }, [])


  const getDashboardCounts = async () => {
    try {
      const response = await miscService.dahsboradCount()

      // console.log(response, "this is dashcount response")
      if (response?.data) {

        setCountData(response.data)
      }
    } catch (err) {
      console.log(err)
    }
  }


  return (
    <div className='aboutus-container'>

      <SEO
        title="About Us"
        description="Learn more about Edraak, India's premier online test series platform for Arabic language competitive exams. Discover our mission, vision, and the innovative approach we bring to education."
        image=""
        url="https://edraakonline.com/aboutUs"
      />

      <div className='aboutusimg-container'>
        {/* <img src='/assets/img/about.png' alt="About Us" className='aboutus-image' /> */}

        <div className="aboutusGetStarted-content" >
          <div className='aboutusGetstarted-firsttxt'>India’s Premier Online Test Series Platform.</div>
          <div className="aboutusGetstarted-headtxt">
            <span>Gateway to </span>
            <span className='aboutusHead-hilight'>Mastering Arabic Language </span>
            <span>Competitive Exams</span>
          </div>
          <div className="aboutusGetstarted-desc">Dive into our extensive collection of MCQs, meticulously crafted to reinforce your understanding of key concepts.</div>
          <div className="aboutusGetstarted-btn-container">
            <div onClick={() => window.location.href = 'https://app.edraakonline.com/login'} className="aboutusGetstarted-btn">Get Started</div>
            <Link to={'/'} className="aboutusDiscover-course-btn">Discover courses</Link>
          </div>
        </div>

        <div className="aboutImgContainer">
          <div className="aboutImg-div">
            <img src="/assets/img/about_pos.png" alt="About Us Position Image" className='aboutPosImg' />
            <img src="/assets/img/about_pos_cap.png" alt="About Us Cap Image" className='aboutCapImg' />
          </div>
        </div>
      </div>

      <div className="aboutusDesc-container">
        <div className="aboutDesc-container container">
          <div data-aos="fade-left" className="count-container">
            <div className="countitem">
              <div className="counttxt">
                <AnimatedCounter end={countData?.total_courses || 0} suffix="+" />
              </div>              <div className="countdesc">Courses listed in app</div>
            </div>

            <div className="countitem">
              <div className="counttxt">
                <AnimatedCounter end={countData?.total_subjects || 0} suffix="+" />
              </div>              <div className="countdesc">Subjects covered</div>
            </div>

            <div className="countitem">
              <div className="counttxt">
                <AnimatedCounter end={countData?.total_topics || 0} suffix="+" />
              </div>              <div className="countdesc">Trending Topics</div>
            </div>

            <a href='https://play.google.com/store/apps/details?id=com.edraakcompete.online&pli=1' target='_blank' rel="noreferrer" className="download-app-container">
                <div className="downloadbtn" >
                  <img
                    src="/assets/img/playstore.png"
                    alt="apple store"
                    className="download-btn"
                  />
                </div>
            </a>
          </div>
          <div data-aos="fade-right" className="aboutDesc-content">
            <div className="desc-welcomeTxt"><span>Welcome to Edraak</span>, a beacon of innovative learning in the educational landscape. Our innovative app combines the power of visual memory and precise definitions to create an engaging and effective learning environment. This unique approach enhances visual memory, promotes critical thinking, and makes learning more interactive. </div>
            <div className="desc-missionTxt">
              <h2>Mission</h2>
              <p className=''>Edraak is on a mission to revolutionize education by providing a diverse range of courses and resources that cater to the evolving needs of learners globally. We aim to bridge gaps, spark curiosity, and foster a lifelong love for learning.</p>
            </div>
          </div>
        </div>
      </div>

      <section class="why-us-section">
        <div class="WhyUsContainer">
          <div className="whyUsContent container">
            <h2 data-aos="fade-down" class="main-title">Why Us</h2>
            <hr class="title-underline" />

            <div data-aos="fade-down" class="contentDescription">
              <p className="address">W W_VO/60,68/1523, 5th Floor, CM Mathew Brothers Arcade, Near Westway hotel, Chakkorathukulam, Calicat-673011</p>
              <ul class="features-list">
                <li><strong>Comprehensive Learning:</strong> Edraak offers a comprehensive platform featuring a diverse array of courses, ensuring a holistic educational experience.</li>
                <li><strong>Inclusive Access:</strong> We believe education should be accessible to all. Edraak provides inclusive access to quality learning resources, breaking down barriers for learners worldwide.</li>
                <li><strong>Innovative Pedagogy:</strong> Our courses are crafted with innovative pedagogy, integrating technology and interactive methods to enhance the learning journey.</li>
                <li><strong>Global Community:</strong> Join a vibrant community of learners, educators, and experts. Edraak fosters collaboration, discussion, and shared knowledge.</li>
              </ul>

              <h3 class="subtitle">Join Us on the Learning Odyssey</h3>
              <p class="description">
                Embark on a learning odyssey with Edraak. Whether you’re a student, professional, or lifelong learner, Edraak welcomes you to explore, discover, and excel in your educational pursuits. Your journey to knowledge begins here.
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}

export default AboutUs